<template>
  <div class="invite-record-page">
    <div class="invite-record-container">
      <div class="header-box">
        <span class="recharge-date">
          <el-select v-model="params.dateType" placeholder="请选择">
             <el-option
                v-for="item in dateTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </span>
        <kx-date-picker 
          v-model="params.beginDate"
          :time-end.sync="params.endDate"/>
        <!--
        <el-date-picker
          class="btn-date-picker"
          v-model="time"
          type="daterange"
          :editable="false"
          :clearable="false"
          align="center"
          range-separator="-"
          placeholder="选择日期范围"
          :picker-options="pickerOptions"
        ></el-date-picker>
        -->
        <el-select v-model="params.usageStatus">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          class="ml20 w200"
          placeholder="请输入卖家微信号"
          v-model.trim="params.wechat" >
        </el-input>
        <el-button @click="invitationalInfo" class="query-btn" v-pointerReClick>查询</el-button>

        <div class="invite-num">邀请数：{{ total }}</div>
      </div>
      <div class="table-box">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :height="getStyle"
          :header-cell-style="{ background: '#f6f8fa' }"
        >
          <el-table-column
            prop="promotionDate"
            label="邀请时间"
            fixed
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginDate"
            label="最后登录时间"
            fixed
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="lastUsageDate"
            label="最后使用时间"
            fixed
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="memberExpiredDate"
            label="会员到期时间"
            fixed
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="nickname"
            label="被邀请人"
            fixed
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="headImageUrl"
            label="被邀请人头像"
            fixed
            align="center"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.headImageUrl"
                alt=""
                v-if="scope.row.headImageUrl"
              />
              <img src="../../assets/use-account/default.png" alt="" v-else />
            </template>
          </el-table-column>
          <el-table-column
            prop="description"
            label="邀请状态"
            fixed
            align="center"
          >
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { invitationalInfo } from '@/api/activity.js'
import { myMixin } from '@/mixins/mixin.js'
import KxDatePicker from '@/components/KxDatePicker'
export default {
  name: 'InviteRecord',
  components: { KxDatePicker },
  props: {},
  mixins: [myMixin],
  data() {
    return {
      dateTypeList: [
        { 
          label: '邀请日期',
          value: 0, 
        }, { 
          label: '最后登录时间',
          value: 1, 
        },  { 
          label: '最后使用时间',
          value: 2, 
        },  { 
          label: '会员到期时间',
          value: 3, 
        },
      ],
      time: [],
      params: {
        beginDate: '',
        endDate: '',
        pageNo: 1,
        pageSize: 10,
        usageStatus: '',
        dateType: 0,
        wechat: '',
      },
      options: [
        {
          value: '',
          label: '邀请状态'
        },
        {
          value: '1',
          label: '邀请成功'
        },
        {
          value: '0',
          label: '已邀请（暂未使用）'
        }
      ],
      tableData: [],
      total: 0,
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      }
    }
  },
  computed: {
    getStyle() {
      if (this.tableData.length > 0) {
        return '100%'
      } else {
        return 'auto'
      }
    }
  },
  watch: {},
  created() {
    /*
    this.time = [new Date(this.getStartDate()), new Date()]
    */
    this.params = Object.assign(this.params, {
      beginDate: this.format(new Date()),
      endDate: this.format(new Date())
    })
    this.invitationalInfo()
  },
  methods: {
    invitationalInfo() {
      this.loading = true
      /*
      this.params.beginDate = this.format(this.time[0])
      this.params.endDate = this.format(this.time[1])
      */
      invitationalInfo(this.params).then(res => {
        this.loading = false
        if (res.success) {
          this.tableData = res.data.data || []
          this.total = res.data.totalRecord
        }
      })
    },
    handleSizeChange(val) {
      this.params.pageSize = val
      this.invitationalInfo()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val
      this.invitationalInfo()
    }
  }
}
</script>

<style scoped lang="scss">
.invite-record-page {
  position: relative;
  width: 1010px;
  height: 100%;
  padding: 20px;
  box-shadow: 0px 2px 12px 0px #edecf6;
  border-radius: 4px;
  .invite-record-container {
    height: 100%;
  }
  .header-box {
    display: flex;
    align-items: center;
    position: relative;
    .recharge-date {
      margin-right: 22px;
    }
    .el-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 66px;
      height: 30px;
      background-color: #3c7cff;
      border-color: #3777ff;
      color: #fff;
      // margin: 0 0 0 22px;
    }
    ::v-deep.el-input__inner {
      width: 200px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }
    ::v-deep.el-icon-arrow-up {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-select {
      ::v-deep.el-input__inner {
        width: 130px;
      }
    }
    .invite-num {
      position: absolute;
      top: 3px;
      right: 75px;
      font-weight: bold;
    }
  }

  ::v-deep.el-date-editor {
    // width: 560px !important;
    height: 30px;
    line-height: 30px !important;
    font-size: 12px !important;
    margin-right: 18px;

    .el-range-input {
      font-size: 12px;
    }

    .el-icon-date {
      margin-top: -8px;
      &::before {
        margin-right: -360px;
      }
    }

    .el-range__icon {
      margin-left: -22px;
    }

    .el-range-separator {
      line-height: 22px;
    }
  }
  .table-box {
    height: calc(100% - 100px);
    margin-top: 20px;
    img {
      width: 66px;
      height: 66px;
    }
    ::v-deep.el-table__header {
      .cell {
        color: #373e4f;
      }
    }
  }
  .block {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
.query-btn{
  margin-left: 10px;
}
</style>
